module.exports = __webpack_public_path__ + "img/security-audit.f380bbaa.jpg";